import { store } from 'components/Store';
import { useContext } from 'react';
import getAppSite from 'utils/getAppSite';

const useCreateInitialResources = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { activePlan } = state;
  const { enableTwitter, enableLiveTranscription } = activePlan;
  const createInitialResources = ({ all }) => {
    let resources =
      getAppSite() === 'usa'
        ? ['KeyUpdates', 'Legislation', 'ParliamentaryRecord']
        : [
            'KeyUpdates',
            'Consultations',
            'Legislation',
            'ParliamentaryRecord',
            'LibraryArticles',
            'Events',
            'CommitteePublications',
          ];
    if ((enableTwitter && import.meta.env.VITE_APP_ENABLE_TWITTER === 'true') || all) {
      resources.push('Tweets');
    }
    if (getAppSite() === 'global') {
      if (enableLiveTranscription || all) {
        resources.unshift('RealtimeUtterances');
      }
    }
    return resources;
  };
  const filterResources = (resources = []) => {
    const allResources = createInitialResources({ all: true });
    // Embed code generated before lords content was added uses CommonsLibraryArticles
    return resources
      .map((resource) => (resource === 'CommonsLibraryArticles' ? 'LibraryArticles' : resource))
      .filter((resource) => allResources.includes(resource));
  };
  return { createInitialResources, filterResources };
};
export default useCreateInitialResources;
